import { Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import MessageManage from "./messages-manage/messages-manage";
import styles from "./message.module.scss";
import ReleaseManage from "./release-manage/release-manage";
import DataSourceManage from "./data-source-manage/data-source-manage";
import FaqManage from "./faq-manage/faq-manage";
import { useTranslation } from "react-i18next";

function Message() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t("userSystem.message")}</div>
      <Tabs value={tab} onChange={handleChangeTab}>
        <Tab label={t("userSystem.notification")} />
        <Tab label={t("userSystem.releaseManage")} />
        <Tab label={t("userSystem.dataSourceManage")} />
        <Tab label={t("userSystem.faqManage")} />
      </Tabs>
      {tab === 0 && <MessageManage />}
      {tab === 1 && <ReleaseManage />}
      {tab === 2 && <DataSourceManage />}
      {tab === 3 && <FaqManage />}
    </div>
  );
}

export default Message;
